import { updatePersonalDataPathFromCheckout } from 'app/services/businessFunctions/helpers/updatePersonalDataPathFromCheckout';

const onCheckoutSecondCoownerNameChange = {
  onCheckoutSecondCoownerNameChange() {
    updatePersonalDataPathFromCheckout();
  },
};

export default onCheckoutSecondCoownerNameChange;
